import React, { useContext } from 'react';

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import messages from '../messages';
import { DeliveryOptionsContext } from './context';

import style from './delivery-options-settings.module.less';
import { useFeatureFlag } from '../../../../../feature-flags/hooks/use-feature-flag';
import { FeatureFlagDeclarations } from '../../../../../feature-flags/feature-flag-declarations';

export const DeliveryOptionHeader = ({ marketplaceName, defaultWarehouseName }) => {
  const { isDeliveryMarketplaceAuctaneFulfillment } = useContext(DeliveryOptionsContext);
  const isLiveRatesWithDimensionsEnabled = useFeatureFlag(FeatureFlagDeclarations.enableLiveRatesWithDimensions);

  return (
    <div className={style['delivery-option-header']}>
      {isDeliveryMarketplaceAuctaneFulfillment ? (
        <>
          <div className={style['delivery-option-description']}>
            <FormattedMessage {...messages.fulfillmentRatesExplanation} />
          </div>
          <div>
            <FormattedMessage {...messages.fulfillmentRatesCalculation} />
          </div>
        </>
      ) : (
        <FormattedMessage {...messages.checkoutRatesExplanation} />
      )}
      <ul className={style['checkout-rates-list']}>
        <li className={style.item}>
          {isDeliveryMarketplaceAuctaneFulfillment ? (
            <FormattedMessage {...messages.fulfillmentRatesProductWeights} />
          ) : (
            <FormattedMessage {...messages.checkoutRatesProductWeights} values={{ marketplaceName }} />
          )}
        </li>
        <li className={style.item}>
          <FormattedMessage {...messages.checkoutRatesWarehouse} values={{ defaultWarehouseName }} />
        </li>
        {isLiveRatesWithDimensionsEnabled && (
          <li className={style.item}>
            <FormattedMessage {...messages.productDimensions} />
          </li>
        )}
        {isDeliveryMarketplaceAuctaneFulfillment && (
          <li className={style.item}>
            <FormattedMessage {...messages.recipientAddress} />
          </li>
        )}
      </ul>
    </div>
  );
};

DeliveryOptionHeader.propTypes = {
  marketplaceName: PropTypes.string,
  defaultWarehouseName: PropTypes.string,
};
